import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/logo-new.png";
import registro from "../../assets/registrro.png";
import cartImg from "../../assets/cart.png";
import dashboard from "../../assets/dashboard.png";
import logoutIcon from "../../assets/logout.png";
import { routes } from "../../helpers/Routes";
import { useAuth } from "../../hooks/useAuth";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Drawer from '@mui/material/Drawer';
import Badge from '@mui/material/Badge';
import { useProductos } from "../../hooks/useProductos";



function Header({ setOpenCart, openCart }) {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const { cart, productos, producto, addCart, getProducto, formatoCOP } = useProductos();

  function toggleDrawer(newOpen) {
    setOpen(newOpen);
  };

  const DrawerList = (
    <Box sx={{ width: 250 }} role="presentation" onClick={() => toggleDrawer(false)}>
      <List>
        {[{ text: 'Bicicletas', link: routes.bicicletas }, { text: 'Nosotros', link: routes.nosotros }, { text: 'Contacto', link: routes.contacto }, { text: 'FAQ', link: routes.faq }].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton>
              <Link to={text.link} style={{ color: "#fff" }}>
                <ListItemText primary={text.text} />
              </Link>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );


  const [isScrolled, setIsScrolled] = useState(false);
  const { usuario, autenticado, usuarioAutenticado, logOut } = useAuth();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50); // Cambia a true si el desplazamiento es mayor a 50px
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };



  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };


  return (
    <>
      <AppBar position="static">
        <header className={isScrolled ? "scrolled-header" : ""}>
          <div className="navbar-nav">
            <Container maxWidth="xl" >
              <Toolbar disableGutters>
                <Typography
                  variant="h6"
                  noWrap
                  component="div"
                  href="#app-bar-with-responsive-menu"
                  sx={{
                    mr: 2,
                    display: { xs: 'none', md: 'flex' },
                    fontFamily: 'monospace',
                    fontWeight: 700,
                    letterSpacing: '.3rem',
                    color: 'inherit',
                    textDecoration: 'none',
                  }}
                >
                  <Link to={routes.home}><img src={logo} width={200} /></Link>
                </Typography>

                <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                  <IconButton
                    size="large"
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={() => toggleDrawer(true)}
                    color="inherit"
                  >
                    <MenuIcon />
                  </IconButton>
                </Box>
                <Typography
                  variant="h5"
                  noWrap
                  component="a"
                  href="#app-bar-with-responsive-menu"
                  sx={{
                    mr: 2,
                    display: { xs: 'flex', md: 'none' },
                    flexGrow: 1,
                    fontFamily: 'monospace',
                    fontWeight: 700,
                    letterSpacing: '.3rem',
                    color: 'inherit',
                    textDecoration: 'none',
                  }}
                >
                  <Link to={routes.home}><img src={logo} width={200} /></Link>
                </Typography>
                <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }} className="nav">
                  <div className="nav-links">
                    <Link to={routes.bicicletas}>Bicicletas</Link>
                    <Link to={routes.nosotros}>Nosotros</Link>
                    <Link to={routes.contacto}>Contacto</Link>
                    <Link to={routes.faq}>FAQ</Link>
                  </div>
                </Box>
                <Box sx={{ flexGrow: 0 }}>
                  <Tooltip title="Open settings" className="button-auth" style={{ display: "none" }}>
                    <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                      <Avatar src="/static/images/avatar/2.jpg" >
                        <AccountCircle />
                      </Avatar>
                    </IconButton>
                  </Tooltip>
                  <Menu
                    sx={{ mt: '45px' }}
                    id="menu-appbar"
                    anchorEl={anchorElUser}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    open={Boolean(anchorElUser)}
                    onClose={handleCloseUserMenu}
                  >
                    <MenuItem>
                      <a style={{ cursor: "pointer", color: "#fff" }} onClick={() => setOpenCart(!openCart)}>Carrito</a>
                    </MenuItem>
                    {!autenticado &&
                      <>
                        <MenuItem>
                          <Link to={routes.login} style={{ textDecoration: "none", color: "#fff" }}>Iniciar Sesion</Link>
                        </MenuItem>
                        <MenuItem>
                          <Link to={routes.registro} style={{ textDecoration: "none", color: "#fff" }}>Registrarse</Link>
                        </MenuItem>
                        {autenticado && usuario?.rol === 0 ?
                          <MenuItem>
                            <Link to={routes.administracion + `/${usuario?.id_usuario}`} style={{ color: "#fff" }}>Dashboard</Link>
                          </MenuItem>
                          : autenticado && usuario?.rol === 1 ?
                            <MenuItem>
                              <Link style={{ color: "#fff" }} to={routes.pedidos + `/${usuario?.id_usuario}`}><img src={dashboard} width={24} /></Link>
                            </MenuItem>
                            : ""
                        }
                      </>
                    }
                    {autenticado &&
                      <MenuItem>
                        <a onClick={() => logOut()}><img src={logoutIcon} width={24} /></a>
                      </MenuItem>
                    }
                  </Menu>
                  <div className="nav-links links-auth">
                  <Badge badgeContent={cart?.length} color="primary">
                  <a style={{ cursor: "pointer", paddingTop: "3px", paddingRight: "3px" }} onClick={() => setOpenCart(!openCart)}><img src={cartImg} width={24} height={24} /></a>
                  </Badge>
                    {!autenticado && <Link to={routes.login} style={{ textDecoration: "none" }}>Iniciar Sesion</Link>}
                    {autenticado && usuario?.rol === 0 ? <Link to={routes.administracion + `/${usuario?.id_usuario}`}><img src={dashboard} width={24} /></Link> :
                      autenticado && usuario?.rol === 1 ? <Link to={routes.pedidos + `/${usuario?.id_usuario}`}><img src={dashboard} width={24} /></Link> : null}
                    {autenticado && <a onClick={() => logOut()}><img src={logoutIcon} width={24} /></a>}
                  </div>
                </Box>
              </Toolbar>
            </Container>
          </div>
        </header>
      </AppBar>


      <Drawer open={open} onClose={() => toggleDrawer(false)}>
        {DrawerList}
      </Drawer>
    </>
  );
}
export default Header;